import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterViewInit{

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    // Defer to next macrotask so DOM is stable (works with *ngIf)
    setTimeout(() => {
      try {
        (this.el.nativeElement as HTMLElement).focus();
      } catch (e) {
        // ignore if cannot focus
      }
    }, 0);
  }

}
